import { PayloadAction } from '@reduxjs/toolkit';

import { MyFleetState } from '../../types';

export const setSelectedMobileLocation = (
  state: MyFleetState,
  action: PayloadAction<MyFleetState['selectedMobileLocation']>
) => {
  state.selectedMobileLocation = action.payload;
};
